import React from "react";
import Repeater from "Components/repeater/Repeater";
import Button from "Components/button/Button";
import Select from "Components/select/Select";
import { tzs, getPanelLangs } from "@/config";
import TranslatedString from "Components/TranslatedString";
import { isValidIPv4CIDR } from "Utils/ip";
import WarningBanner from "Components/warningBanner/WarningBanner";
import ChangePasswordModal from "Components/changePasswordModal/ChangePasswordModal";
import ApiTokenGenerator from "Components/apiTokenGenerator/ApiTokenGenerator";
import OTP from "../OTP";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import t from "Utils/translation";
import cx from "classnames";
import { getCookie } from "../../../config";
import { connect } from "react-redux";
import * as sessionActions from "../../../modules/session";
import s from "./panelSettings.scss";
import _ from "lodash";
import QboxmailApi from "@/qboxmailApi";
import { view, store } from "@risingstack/react-easy-state";
import Toggle from "Components/toggle/Toggle";

class PanelSettings extends React.Component {
  state = {
    changePwdModalOpened: false,
    copied: false,
  };

  sessions = store({
    deleting: {},
    deleted: {},
  });

  submitAndCloseModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.submitForm(e).then(() => this.closeModal());
  };

  deleteSession = async (id) => {
    this.sessions.deleting[id] = true;
    const api = new QboxmailApi({ useCookie: true });
    try {
      await api.deleteSession(this.props.session.user.code, id);
    } catch (e) {
      console.error(e);
      this.sessions.deleting[id] = false;
      return;
    }
    this.props.refreshLoggedUserData();
    this.sessions.deleting[id] = false;
    this.sessions.deleted[id] = true;
  };

  openModal = () => {
    this.setState({ changePwdModalOpened: true });
  };

  closeModal = () => {
    this.setState({ changePwdModalOpened: false });
    this.props.setFormFieldValue({ password: "", password_confirmation: "" });
    this.props.setFormErrors({ password: "", password_confirmation: "" });
  };

  saveAndRefresh = (e) => {
    this.props.submitForm(e);
    this.props.refreshLoggedUserData();
  };

  render() {
    const {
      className,
      user,
      generateApiToken,
      destroyApiToken,
      apiToken,
      isGeneratingToken,
      isResettingToken,
      apiTokenResetted,
      formData,
      setFormFieldValue,
      submitForm,
      isFormLoading,
      formErrors,
      domain,
    } = this.props;

    let canUseAPI = true;
    if (user.type === "TeamMember" && !user.permissions.includes("use_api")) {
      canUseAPI = false;
    }
    if ((user.type === "EmailAccount" || user.type === "Postmaster") && (!domain.api_enabled || !user.api_enabled)) {
      canUseAPI = false;
    }

    return (
      <form className={cx(className, s.general)} method="post" onSubmit={this.saveAndRefresh.bind(this)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine("language", "timezone", "allow_nets") && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>
          <div className={s.infoBtnGroup}>
            <Button docsKey="user_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>

        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.languageTimeZone.title")}</div>
              <div className="sectionDesc">{t("settings.sections.languageTimeZone.desc.panel")}</div>
            </div>
            <div className="formsSectionSP">
              <Select
                label={t("input.label.language")}
                components={{ DropdownIndicator }}
                name="language"
                options={getPanelLangs()}
                onChange={setFormFieldValue}
                value={formData.language}
                clearable={false}
              />

              <Select
                label={t("input.label.timezone")}
                components={{ DropdownIndicator }}
                name="timezone"
                options={tzs}
                initialValue={user.timezone}
                clearable={false}
                onChange={setFormFieldValue}
                value={formData.timezone}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.password.title")}</div>
              <div className="sectionDesc">{t("settings.sections.password.desc.panel")}</div>
            </div>
            <div className="formsSectionSP">
              <Button className={s.btnPassword} type="button" color="outline" onClick={this.openModal}>
                button.passwordChange
              </Button>
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("input.label.remembered.devices")}</div>
              <div className="sectionDesc">
                <TranslatedString>input.hint.remembered.devices</TranslatedString>
              </div>
            </div>

            <div className="formsSectionSP">
              {user.sessions && (
                <div className={cx(s.remeberDevices)}>
                  <div className={s.otpSessioneList}>
                    <div className={s.headerOtpSL}>
                      <div>{t("listTable.header.title.browser")}</div>
                      <div>{t("listTable.header.title.platform")}</div>
                    </div>

                    <div className={s.contentOtpSL}>
                      {user.sessions.length === 0 && <div className={s.emptyList} />}

                      {user.sessions &&
                        _.compact(
                          user.sessions.map((sess) => {
                            if (this.sessions.deleted[sess.id]) return undefined;

                            return (
                              <div key={sess.token} className={s.rowOtpSL}>
                                <div className={s.browser}>
                                  {sess.useragent.browser} <span>{sess.useragent.browser_version}</span>
                                </div>
                                <div>{sess.useragent.platform}</div>
                                <div>
                                  {sess.useragent.raw === navigator.userAgent &&
                                    sess.token === getCookie("device_token") && (
                                      <span className={s.current}>{t("detailInfo.data.currentSession")}</span>
                                    )}
                                </div>

                                <Button
                                  className={s.btnRD}
                                  color="red"
                                  onClick={() => this.deleteSession(sess.id)}
                                  loading={this.sessions.deleting[sess.id]}
                                >
                                  button.delete
                                </Button>
                              </div>
                            );
                          })
                        )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.otp.title")}</div>
              <div className="sectionDesc">{t("settings.sections.otp.desc.panel")}</div>
            </div>
            <div className="formsSectionSP">
              <OTP className="inputFull2" />
            </div>
          </div>

          {user.type !== "EmailAccount" && (
            <div className="sectionSP">
              <div className="infoSectionSP">
                <div className="settingTitle">{t("settings.sections.ipEnabled.title")}</div>
                <div className="sectionDesc">{t("settings.sections.ipEnabled.desc.panel")}</div>
              </div>
              <div className="formsSectionSP">
                <Repeater
                  className="inputFull2"
                  labelInput={t("input.label.add.ipAddress")}
                  label={t("listTable.header.title.ipEnabled")}
                  name="allow_nets"
                  onChange={setFormFieldValue}
                  values={formData.allow_nets || []}
                  maxValues={5}
                  errors={formErrors.allow_nets}
                  placeholder={t("input.placeholder.ip")}
                  validateNewValue={(newVal) => {
                    if (!isValidIPv4CIDR(newVal)) {
                      alert(t("alert.ipAddressInvalid", null, { ip: newVal }));
                      return false;
                    }

                    if (formData.allow_nets?.includes(newVal)) {
                      alert(t("alert.ipAddressAlreadyListed", null, { ip: newVal }));
                      return false;
                    }

                    return true;
                  }}
                />
              </div>
            </div>
          )}

          {user.type == "Customer" && (
            <div className="sectionSP">
              <div className="infoSectionSP">
                <div className="flex items-center gap-2 settingTitle">
                  {t("settings.sections.tracemail21DaysLimitDefault.title")}
                </div>
                <div className="sectionDesc">{t("settings.sections.tracemail21DaysLimitDefault.desc")}</div>
              </div>
              <div className="formsSectionSP">
                <Toggle
                  className="inputFull2"
                  label={t("input.label.tracemail21DaysLimitDefault")}
                  name="domain_limit_tracemail_21_days_default"
                  checked={formData.domain_limit_tracemail_21_days_default}
                  errors={formErrors.domain_limit_tracemail_21_days_default}
                  onChange={setFormFieldValue}
                />
              </div>
            </div>
          )}

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.api.title")}</div>
              <div className="sectionDesc">{t("settings.sections.api.desc.panel")}</div>
            </div>
            <div className="formsSectionSP">
              {!canUseAPI && <div className={cx(s.disabledMsg, "inputFull2")}>{t("infoMsg.apiUsage.disabled")}</div>}

              {canUseAPI && (
                <ApiTokenGenerator
                  className="inputFull2"
                  token={apiToken || (!apiTokenResetted && user.api_token)}
                  generate={() => generateApiToken(user.code)}
                  destroy={() => destroyApiToken(user.code)}
                  loading={isGeneratingToken}
                  resetting={isResettingToken}
                />
              )}
            </div>
          </div>
        </div>

        <ChangePasswordModal
          opened={this.state.changePwdModalOpened}
          handleClose={this.closeModal}
          handleResetPassword={this.submitAndCloseModal}
          isFormLoading={isFormLoading}
          formData={this.props.formData}
          setFormFieldValue={this.props.setFormFieldValue}
          formErrors={this.props.formErrors}
          confirmSelfPassword
        />
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  refreshLoggedUserData: () => {
    dispatch(sessionActions.verify(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelSettings);
